import httpStore from "@/api/httpStore.js";

export function getOrderInformation(orderNumber) {
  const url = `/nkrsync/order/${orderNumber}`;
  return httpStore.get(url).then(res => {
    return res.data;
  });
}

// update order in nkr sync
export function updateSyncApi(orderNumber) {
  const url = `/nkrsync/order_update/${orderNumber}`;
  return httpStore.put(url).then(res => {
    return res.data;
  });
}

export function sendOrderToInfoauto(orderNumber) {
  const url = `/nkrsync/order_send_to_infoauto/${orderNumber}`;
  return httpStore.post(url).then(res => {
    return res.data;
  });
}

export function sendNotificationMessage(orderNumber, message) {
  const url = `/nkrsync/free_text_message`;
  return httpStore.post(url, { orderNumber, message }).then(res => {
    return res.data;
  });
}
